import type { FaireProductEntity } from "../../entity_types/product";

export const p_e2g7y6zkck: FaireProductEntity = {
  token: "p_e2g7y6zkck",
  type: "product",
  name: "Palo Santo - elsewhere Collection Incense Cones",
  brandToken: "b_oaph28jf",
  brandName: "dilo",
  imageUrl:
    "https://cdn.faire.com/fastly/ab8a11001dadc483870ab91ac37796c8ed929205ab0b14350546751e613664a8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a35c712b9980bec9018faf60673e0ad7fca1e73d7d7679b9c13e0da6580f9af.jpeg",
    "https://cdn.faire.com/fastly/c811193afd2faf1f6e12bb6488ded40a68e96f099a414bd896f60c919b0cfec8.jpeg",
    "https://cdn.faire.com/fastly/478ad1accc2122d4fa4f8a5bece27f67427fa4eabd6d3efa3e852ecaa14e7a42.jpeg",
    "https://cdn.faire.com/fastly/a1b35110881be33e24ed6ccb3fe4b469dee93ff756234304dcfa7ddd1d476c7d.jpeg",
    "https://cdn.faire.com/fastly/b7adf11729fdd04e65892e056aaf6bdf84f8db4864f26badcbf3fa952fbf1f2d.png",
  ],
  priceDollars: 10,
  description:
    " Tin contains 25 Incense Cones - Resin + Fragrance\n\nPalo Santo - Smokey peppercorn notes toned down by Amber Resin and Palo Santo Wood.\n\nOR choose from 3 other elsewhere Fragrance Profiles\n\nCactus Flower - Bright notes of Mandarin and Bergamot settle into a Mossy Redwood Smoke. \n\nHinoki Sesame - Coastal Sea Salt Air rises through Centuries-Old Hinoki Cypress Trees\n\nDesert Kush - Juicy Yuzu and Grapefruit on top of a Hempy Kushy Pillow of Smoky Teakwood\n\nFIND THE WHOLE SET OF 4 - HERE\n",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:13.484Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
